/**
 * Debug utility for the application
 * Only logs when ?debug is present in the URL
 */

/**
 * Check if debug mode is enabled via URL parameter
 */
function isDebugMode(): boolean {
  if (typeof window === 'undefined') return false;
  return new URLSearchParams(window.location.search).has('debug');
}

/**
 * Conditional console.log that only logs when debug mode is enabled
 */
export function debugLog(...args: any[]): void {
  if (isDebugMode()) {
    console.log(...args);
  }
}

/**
 * Conditional console.warn that only logs when debug mode is enabled
 * Note: For production-critical warnings, use console.warn directly
 */
export function debugWarn(...args: any[]): void {
  if (isDebugMode()) {
    console.warn(...args);
  }
}

/**
 * Conditional console.error that only logs when debug mode is enabled
 * Note: For production-critical errors, use console.error directly
 */
export function debugError(...args: any[]): void {
  if (isDebugMode()) {
    console.error(...args);
  }
}

/**
 * Check if we're in debug mode (useful for conditional logic)
 */
export function isDebugEnabled(): boolean {
  return isDebugMode();
}
